import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService } from '../services/spinner.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly modalService: NgbModal,
    private readonly authService: AuthService,
    private readonly spinnerService: SpinnerService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe<HttpEvent<any>>(
      catchError<HttpEvent<any>, Observable<HttpEvent<any>>>((err: any) => {
        this.spinnerService.reset();
        if (err.status === 401 && this.authService.isTokenExpired()) {
          this.modalService.dismissAll();
          this.authService.logout('Token scaduto');
        }
        return throwError(() => err);
      })
    );
  }
}
